import * as React from "react";
import styled from "styled-components";
const ModalContainer = styled.div `
	& > img {
		display: block;
		margin: 14px auto 9px;
		max-width: 230px;
	}
`;
const ModalHeader = styled.h1 `
	font-size: 18px;
	font-weight: 500;
	color: #333;
	line-height: 21px;
	padding: 0;
	margin: 0;
	text-decoration: none;
	text-align: center;
	margin-top: 5px;
`;
const Subscript = styled.p `
	font-size: 12px;
	color: #666;
	line-height: 14px;
	text-align: center;
	margin: 9px 0 15px;
`;
const Description = styled.p `
	font-size: 14px;
	color: #333;
	line-height: 16px;
	text-align: center;
	margin: 0;
`;
export function getVoucherModalContent(voucher) {
    const getDate = (startSpan, endSpan) => {
        let startDate = new Date(parseInt(startSpan, 10) * 1000).toLocaleDateString();
        let endDate = new Date(parseInt(endSpan, 10) * 1000).toLocaleDateString();
        return `${startDate}-${endDate}`;
    };
    return (React.createElement(ModalContainer, null,
        React.createElement(ModalHeader, null, "Congratulation! You have got"),
        React.createElement("img", { src: voucher === null || voucher === void 0 ? void 0 : voucher.img, alt: "" }),
        React.createElement(Subscript, null,
            "Expired Date: ",
            getDate(voucher.start, voucher.end)),
        React.createElement(Description, null, "Use this voucher upon check out to enjoy great discounts!")));
}
